import VuexPersistence from 'vuex-persist';
import initialState from './initialState';

const { localStorage } = window;

export const persistedStorageKey = 'pepper_business';

// Read and parse the persisted store. Both halves are guarded, because both
// throw: `getItem` itself raises where storage is unavailable (Safari private
// browsing, storage disabled by policy), and the value can be corrupt. Neither
// may throw for any of this key's readers — one of them runs before Vuetify
// boots, where a throw takes the whole app down rather than one feature.
export const readPersistedStore = () => {
  try {
    return JSON.parse(localStorage.getItem(persistedStorageKey)) ?? {};
  } catch {
    return {};
  }
};

export default new VuexPersistence({
  storage: localStorage,
  key: persistedStorageKey,
  // reducer deletes fields from persisted state, the fields which are not listed in the reducer stay the same after the page is refreshed
  reducer: (state) => ({
    ...state,
    alerts: initialState.alerts,
    creatorProgram: {
      ...state.creatorProgram,
      businesses: initialState.creatorProgram.businesses,
    },
    threads: {
      ...initialState.threads,
      commentPermissions: state.threads.commentPermissions,
    },
    reports: initialState.reports,
    comments: initialState.comments,
    contracts: {
      ...initialState.contracts,
      statuses: state.contracts.statuses,
      types: state.contracts.types,
    },
    billing: initialState.billing,
    payments: {
      ...initialState.payments,
      statuses: state.payments.statuses,
    },
    invoices: initialState.invoices,
    labels: initialState.labels,
    businesses: {
      ...initialState.businesses,
      statuses: state.businesses.statuses,
      notificationTypes: state.businesses.notificationTypes,
    },
    users: {
      ...initialState.users,
      roles: state.users.roles,
      statuses: state.users.statuses,
      countries: state.users.countries,
    },
    validation: initialState.validation,
    pins: initialState.pins,
    packages: initialState.packages,
    schedules: initialState.schedules,
    siteMessages: {
      ...initialState.siteMessages,
      statuses: state.siteMessages.statuses,
    },
    grids: initialState.grids,
    adManager: initialState.adManager,
    tracking: {
      ...state.tracking,
      activeAdvertiser: initialState.tracking.activeAdvertiser,
      advertiserDomains: initialState.tracking.advertiserDomains,
    },
  }),
});
